import { Injectable } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth';
import { Store } from '@ngxs/store';
import { Observable, from, of } from 'rxjs';
import { first, switchMap, tap } from 'rxjs/operators';

import { SetToken } from '@fitscovery/auth/data-access';

@Injectable()
export class RefreshTokenService {

	constructor (
    private store: Store,
    private auth: AngularFireAuth,
  ) { }

  getAndSetNewTokenToState(): Observable<any> {
    return this.auth.authState.pipe(
      first(),
      switchMap((e: any) => 
        e?.getIdToken(true) 
        ? from(e.getIdToken(true)).pipe(tap((token: any) => this.store.dispatch(new SetToken(token)))) 
        : of(false))
    )
  }

}
